// Metrics the mobile idea card can show next to Current MV (always shown).
export const MOBILE_VIEW_CARD_FIELDS = [
  'dailyReturnPct',
  'quarterlyReturnPct',
  'dailyPnl',
  'quarterPnl',
] as const
export type MobileViewCardField = (typeof MOBILE_VIEW_CARD_FIELDS)[number]
export const MOBILE_VIEW_CARD_FIELDS_DEFAULT: MobileViewCardField[] = [
  'dailyReturnPct',
  'quarterlyReturnPct',
]
export const MOBILE_VIEW_CARD_FIELDS_MAX = 2
export const MOBILE_VIEW_CARD_FIELD_LABEL_KEYS: Record<
  MobileViewCardField,
  string
> = {
  dailyReturnPct: 'idea_list.idea_table.columns.daily_return_pct',
  quarterlyReturnPct: 'idea_list.idea_table.columns.quarterly_return_pct',
  dailyPnl: 'idea_list.idea_table.columns.daily_pnl',
  quarterPnl: 'idea_list.idea_table.columns.quarter_pnl',
}

// Backend `orderBy` keys for the mobile card list, stored as `Field/Direction`.
export const MOBILE_VIEW_CARD_ORDER_OPTIONS = [
  'DailyReturnPct',
  'QuarterlyReturnPct',
  'DailyPnl',
  'QuarterPnl',
  'CreatedAt',
] as const
export type MobileViewCardOrderField =
  (typeof MOBILE_VIEW_CARD_ORDER_OPTIONS)[number]
export const MOBILE_VIEW_CARD_ORDER_LABEL_KEYS: Record<
  MobileViewCardOrderField,
  string
> = {
  DailyReturnPct: 'idea_list.idea_table.columns.daily_return_pct',
  QuarterlyReturnPct: 'idea_list.idea_table.columns.quarterly_return_pct',
  DailyPnl: 'idea_list.idea_table.columns.daily_pnl',
  QuarterPnl: 'idea_list.idea_table.columns.quarter_pnl',
  CreatedAt: 'idea_list.view_config.created_time',
}

export const MOBILE_VIEW_CARD_ORDER_DIRECTIONS = ['DESC', 'ASC'] as const
export type MobileViewCardOrderDirection =
  (typeof MOBILE_VIEW_CARD_ORDER_DIRECTIONS)[number]
export const MOBILE_VIEW_CARD_ORDER_DEFAULT = 'CreatedAt/DESC'
